<template>
  <span
    v-if="levelKey"
    class="bonus-level-badge inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-2xs font-semibold uppercase"
    :class="levelKey"
  >
    <OurSvgIcon
      v-if="iconSrc"
      class="shrink-0"
      :src="iconSrc"
      size="2xs"
      :color="iconColor"
      variant="light"
    />
    {{ label }}
  </span>
  <span v-else class="text-sm text-gray-400">–</span>
</template>

<script>
const LEVEL_LABELS = {
  welcome: "WELCOME",
  bronze: "BRONZE",
  silver: "SILVER",
  gold: "GOLD",
};

export default {
  name: "BonusProgramLevelBadge",

  props: {
    level: {
      type: String,
      default: "",
    },
  },

  computed: {
    levelKey() {
      const normalized = (this.level || "").toLowerCase().trim();

      return LEVEL_LABELS[normalized] ? normalized : "";
    },

    label() {
      return LEVEL_LABELS[this.levelKey] || "";
    },

    icons: () => ({
      Crown: require("@/components/_bit/IconSvg/icons/Crown.svg"),
      Shield: require("@/components/_bit/IconSvg/icons/Shield-check.svg"),
      User: require("@/components/_bit/IconSvg/icons/User.svg"),
    }),

    iconSrc() {
      if (this.levelKey === "gold" || this.levelKey === "silver") {
        return this.icons.Crown;
      }

      if (this.levelKey === "bronze") {
        return this.icons.Shield;
      }

      if (this.levelKey === "welcome") {
        return this.icons.User;
      }

      return null;
    },

    iconColor() {
      if (this.levelKey === "gold") {
        return "yellow";
      }

      if (this.levelKey === "silver") {
        return "gray";
      }

      if (this.levelKey === "bronze") {
        return "orange";
      }

      return "gray";
    },
  },
};
</script>

<style lang="postcss" scoped>
.bonus-level-badge {
  &.welcome {
    @apply bg-gray-100 text-gray-500;
  }

  &.bronze {
    @apply bg-orange-50 text-[#d28c3a];
  }

  &.silver {
    @apply bg-gray-100 text-[#6b839a];
  }

  &.gold {
    @apply bg-yellow-100 text-[#dd8e00];
  }
}
</style>
